export default "__VITE_ASSET__DOJV2hZB__"